import React from 'react';
import AdvanceFilter from '../../../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../../../component/Filter/advanceFilterOptions';

function VendorAdvanceFilter({
	handleOnFocusSelectedFilterInput,
	searchSelectedInputItems,
	isAdvanceFilterModalOpen,
	setIsAdvanceFilterModalOpen,
	handleApplyFilters,
}) {
	return (
		<AdvanceFilter
			modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
			isOpen={isAdvanceFilterModalOpen}
			advanceFilterOptions={advanceFilterOptions?.vendor}
			onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
			handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
			onClose={() => {
				setIsAdvanceFilterModalOpen(false);
			}}
			onApply={handleApplyFilters}
		/>
	);
}

export default VendorAdvanceFilter;
